"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const abs_1 = require("./abs");
const math_1 = require("./math");
const column_1 = require("./column");
const number_1 = require("./number");
const power_1 = require("./power");
const sign_1 = require("./sign");
const sqrt_1 = require("./sqrt");
const error_1 = require("../../error");
function deserializeCalc(obj) {
    let nodeTypes = [abs_1.default, math_1.default, column_1.default, number_1.default, power_1.default, sign_1.default, sqrt_1.default];
    for (let nodeType of nodeTypes) {
        let node = nodeType.from(obj, deserializeCalc);
        if (node)
            return node;
    }
    throw new error_1.default('Unsupported calculation graph');
}
exports.default = deserializeCalc;
